import type { RecipeVariants } from "@vanilla-extract/recipes";
import clsx from "clsx";
import * as styles from "./CTA.css";
import type { Props } from "./types";

export default function CtaAnchor({
	children,
	colors,
	icon,
	iconPosition,
	size,
	badge,
	animated,
	wide,
	counter,
	className,
	active,
	label,
	...props
}: Props &
	RecipeVariants<typeof styles.button> &
	React.AnchorHTMLAttributes<HTMLAnchorElement>) {
	return (
		<a
			className={clsx(
				styles.button({
					colors,
					size,
					badge,
					animated,
					wide,
					counter,
					label,
					active,
					iconPosition,
				}),
				className,
			)}
			{...props}
		>
			<span className={styles.wrap}>
				{icon && <span className={styles.iconContainer}>{icon}</span>}
				<span className={styles.children}>{children}</span>
			</span>
		</a>
	);
}
